<template>
  <div
    :class="{ 'form-popup-overlay': true, 'is-visible': isVisible, 'px-5': true }"
    @click="hide">
    <div
      :class="{ 'form-popup': true, 'px-5': true, 'pb-4': true, 'pt-4': true, 'is-loading': loading }"
      @click.stop>
      <h3 class="text-center">
        {{ popupTitle }}
      </h3>

      <validation-observer ref="permission-form" tag="form">
        <d-row>
          <div class="form-group w-100">
            <label for="start">Start:</label>
            <d-input v-model="data.start" />
          </div>
        </d-row>

        <d-row>
          <div class="form-group w-100">
            <label for="country_id">Country:</label>

            <validation-provider
              rules="required"
              name="country_id"
              v-slot="{ errors }">
              <div :class="{ 'form-control': true, 'is-select': true, 'is-invalid': errors.length }">
                <v-select
                  :options="countriesOptions"
                  v-model="data.country_id"
                  :reduce="country => country.id"
                  placeholder="Select a country"
                  label="text"
                  @input="updateValidity">
                  <template slot="no-options">
                    There are no countries for the provided phrase&hellip;
                  </template>
                </v-select>
              </div>
              <div class="invalid-feedback">
                {{ errors[0] }}
              </div>
            </validation-provider>
          </div>
        </d-row>

        <d-row>
          <div class="form-group w-100">
            <label for="entry_point">Entry point:</label>
            <d-input v-model="data.entry_point" />
          </div>
        </d-row>

        <d-row>
          <div class="form-group w-100">
            <label for="eet">EET:</label>
            <d-input v-model="data.eet" />
          </div>
        </d-row>

        <d-row>
          <div class="form-group w-100">
            <label for="number">Number:</label>
            <d-input v-model="data.number" />
          </div>
        </d-row>

        <d-row>
          <div class="form-group w-100">
            <label for="validity">Validity:</label>
            <d-input v-model="data.validity" />
          </div>
        </d-row>

        <d-row class="mb-4">
          <d-col cols="6">
            <d-checkbox
              inline
              v-model="data.confirmed"
              toggle>
              Confirmed
            </d-checkbox>
          </d-col>

          <d-col cols="6">
            <d-checkbox
              inline
              v-model="data.requested"
              toggle
              class="is-warning">
              Requested
            </d-checkbox>
          </d-col>
        </d-row>
      </validation-observer>

      <d-row>
        <div class="text-center w-100">
          <d-button
            @click.prevent="validateForm"
            theme="success"
            class="mr-5">
            Save
          </d-button>

          <d-button
            @click.prevent="cancel"
            outline
            theme="secondary">
            Cancel
          </d-button>
        </div>
      </d-row>
    </div>
  </div>
</template>

<script>
import CommonGetters from './../../utils/CommonGetters.js';
import FormUtils from './../../utils/FormUtils';

export default {
  name: 'PermissionPopup',
  computed: {
    popupTitle () {
      if (this.mode === 'add') {
        return 'Add permission';
      }

      return 'Edit permission';
    },
    countriesOptions () {
      return CommonGetters.getCountriesForSelect(this.countries);
    }
  },
  watch: {
    'data.confirmed': function (newValue) {
      this.data.requested = newValue;
    }
  },
  data () {
    return {
      isVisible: false,
      mode: 'add',
      loading: false,
      countries: [],
      loadedCountries: false,
      loadError: false,
      data: {
        id: false,
        country_id: null,
        valid_for: null,
        end_date: null,
        reference_type: null,
        reference_id: null
      }
    };
  },
  mounted () {
    this.$bus.$on('show-permission-popup', this.show);
    this.$bus.$on('countries-list-reload', this.loadAdditionalData);
    this.loadAdditionalData();
  },
  methods: {
    show (mode, flightId = false, documentId = false) {
      this.mode = mode;

      if (mode === 'add') {
        this.loading = false;
        this.data = {
          id: false,
          start: '',
          country_id: null,
          entry_point: '',
          eet: '',
          number: '',
          validity: '',
          confirmed: false,
          requested: false,
          flight_id: flightId
        };
      } else {
        this.loading = true;
        this.loadPermissionData(documentId);
      }

      setTimeout(() => {
        this.$refs['permission-form'].reset();
        this.isVisible = true;
      }, 100);
    },
    loadPermissionData (permissionId) {
      FormUtils.loadItemData(this, {
        id: permissionId,
        endpointBase: '/trips/permissions/item/',
        instanceFields: ['id', 'start', 'flight_id', 'country_id', 'validity', 'eet', 'entry_point', 'number', 'confirmed', 'requested'],
        loadedKey: 'loaded',
        successAction: () => {
          this.loading = false;
          this.data.confirmed = !!this.data.confirmed;
          this.data.requested = !!this.data.requested;
          this.$refs['permission-form'].reset();
        }
      });
    },
    loadAdditionalData () {
      FormUtils.loadAdditionalData(this, {
        endpoint: '/countries/items',
        params: {
          pagination: 0
        },
        loadedKey: 'loadedCountries',
        outputKey: 'countries',
        errorKey: 'loadError'
      });
    },
    validateForm () {
      FormUtils.validate(this.$refs['permission-form'], this.submitForm);
    },
    submitForm () {
      this.loading = true;
      let endpointUrl = '/trips/permissions/store';

      if (this.mode === 'edit') {
        endpointUrl = '/trips/permissions/update/' + this.data.id;
      }

      let formDataToSend = this.prepareFormData();

      FormUtils.submit({
        $http: this.$http,
        endpoint: endpointUrl,
        formData: formDataToSend,
        successTitle: this.mode === 'add' ? 'Permission added' : 'Permission saved',
        successText: '',
        errorTitle: 'An error occurred',
        errorText: 'The system was unable to save the visa. Please try again.',
        successAction: () => {
          this.loading = false;
          this.isVisible = false;
          this.$bus.$emit('permissions-list-reload');
        }
      });
    },
    cancel () {
      this.isVisible = false;
      this.loading = false;
    },
    hide () {
      this.isVisible = false;
      this.loading = false;
    },
    prepareFormData () {
      let dataToSend = {
        start: this.data.start,
        country_id: this.data.country_id,
        entry_point: this.data.entry_point,
        eet: this.data.eet,
        number: this.data.number,
        flight_id: this.data.flight_id,
        validity: this.data.validity,
        confirmed: this.data.confirmed,
        requested: this.data.requested
      };

      return dataToSend;
    },
    updateValidity () {
      if (this.data.country_id) {
        let countryData = this.countries.filter(country => country.id === this.data.country_id);

        if (countryData[0]) {
          this.data.validity = countryData[0].validity;
        } else {
          this.data.validity = '';
        }
      } else {
        this.data.validity = '';
      }
    }
  },
  beforeDestroy () {
    this.$bus.$off('show-permission-popup', this.show);
    this.$bus.$off('countries-list-reload', this.loadAdditionalData);
  }
}
</script>
